<template>
  <div class="rounded-xl overflow-hidden">
    <absences-virtual-scroller
      v-if="dataLoaded"
      :remaining-height="remainingHeight"
      :columns="columns"
      :items="items"
      :isDispoView="mx_isDispoView"
      :isZueri9View="mx_isZueri9View"
      :sortColumn="sortColumn"
      defaultSortedColumn="reportedAtTime"
      defaultSortedColumnDirection="desc"
      @inlineChange="(args) => onInlineChange(args)"
      @copyAction="copyItem"
      @editAction="editItem"
      @deleteAction="showDeleteDialog"
      @forwardAction="showForwardDialog"
      @restoreAction="showRestoreDialog"
      @mailAction="createMailto"
      @onSortColumn="onSortColumn"
    >
      <template v-slot:top>
        <v-toolbar flat class="pt-2 pr-10">
          <div class="d-flex flex-column justify-start align-start">
            <div class="text-h6">Worksheet</div>
          </div>
          <v-spacer></v-spacer>
          <div style="display: flex; width: 180px !important">
            <v-text-field v-model="search" outlined rounded dense placeholder="Suchen nach" clearable class="mt-4 mx-2"></v-text-field>
          </div>
          <!--          <div class="d-flex flex-column align-end mr-8 d-print-none" style="margin-top: -8px">-->
          <!--            <sort-column :sort-fields="sortColumns"></sort-column></div>-->
          <div class="d-flex flex-column align-end mr-8 d-print-none" style="margin-top: -8px">
            <v-btn-toggle v-if="mx_isDispoView || mx_isZueri9View" mandatory rounded v-model="absenceDisplayMode" color="primary">
              <v-btn small value="active">aktive</v-btn>
              <v-btn small value="all">alle</v-btn>
              <v-btn small value="deleted">gelöschte</v-btn>
            </v-btn-toggle>
          </div>
          <div class="d-flex flex-column align-end mr-8 d-print-none" style="margin-top: -8px">
            <state-filter v-if="mx_isDispoView" :states="dispoStates" v-model="selectedDispoStates"></state-filter>
            <state-filter v-if="mx_isZueri9View" :states="zueri9States" v-model="selectedZueri9States"></state-filter>
            <!--
            <v-menu v-else-if="mx_isZueri9View" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="py-1 d-print-none font-weight-bold overflow-hidden"
                  outlined
                  color="primary"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  style="text-overflow: ellipsis; width: 150px !important"
                  :style="selectedZueri9State ? `color:white !important;background:${selectedZueri9State.bgColor}` : ''"
                >
                  {{ selectedZueri9State ? selectedZueri9State.text : 'Status Filter' }}
                  <v-icon right>mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(state, index) in zueri9States" :key="index" @click="selectedZueri9State = state">
                  <v-chip width="100%" :style="`background:${state.bgColor};color:white`">{{ state.text }}</v-chip>
                </v-list-item>
                <v-list-item @click="selectedZueri9State = null">
                  <v-list-item-title>alle</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            -->
          </div>
          <v-btn v-if="!mx_isZueri9CustomerView" small outlined color="primary" dark class="mb-2 d-print-none" @click="createItem"> Neuer Eintrag </v-btn>
          <!-- for the time being disabled. export is the better solution in any case -->
          <v-btn v-if="false" small outlined color="primary" dark class="mb-2 ml-4 d-print-none" onclick="window.print()">
            <v-icon class="pr-2">mdi-printer</v-icon>
            Drucken
          </v-btn>
          <v-btn v-if="!mx_isZueri9CustomerView" small outlined color="primary" dark class="mb-2 ml-1 d-print-none" @click="exportCsv">Export</v-btn>
          <v-btn
            v-if="mx_isDispoView"
            :disabled="!selectedItems.length"
            small
            outlined
            color="primary"
            class="mb-2 ml-1 d-print-none"
            @click="showMultipleForwardDialog(selectedItems)"
            >{{ selectedItems.length }} selektierte weiterleiten</v-btn
          >
          <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Zeile {{ editedItem.deleted ? 'reaktivieren' : 'löschen' }}?</v-card-title>
              <v-card-text
                >Wollen Sie den Eintrag vom {{ formatIsoDateStringAsLocaleShortDate(editedItem.reportedAtTime) }}
                {{ formatTime(editedItem.reportedAtTime) }} wirklich {{ editedItem.deleted ? 'reaktivieren' : 'löschen' }}?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="cancelDelete">Abbrechen</v-btn>
                <v-btn color="primary" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn v-if="mx_isZueri9View" class="mb-2 ml-1" outlined color="primary" dark small @click="fahrdienstStatsDialog = true">Statistik</v-btn>
          <v-dialog v-if="mx_isZueri9View" v-model="fahrdienstStatsDialog" persistent max-width="700">
            <!--            <template v-slot:activator="{ on, attrs }">-->
            <!--              <v-btn class="mb-2 ml-1" outlined color="primary" dark small v-bind="attrs" v-on="on">Statistik</v-btn>-->
            <!--            </template>-->
            <fahrdienst-stats
              :zueri9FahrstundenTagesRichtwert="zueri9FahrstundenTagesRichtwert"
              :fahrdienst-stats="zueri9FahrdienstStats"
              @close="fahrdienstStatsDialog = false"
            ></fahrdienst-stats>
          </v-dialog>
          <v-badge
            v-if="mx_isZueri9View && mx_openAbsencesAtSelectedDateInZueri9View.length > 0"
            :color="mx_zueri9OpenStateColor"
            :content="mx_openAbsencesAtSelectedDateInZueri9View.length"
            offset-x="-20"
            offset-y="-10"
          ></v-badge>
          <v-badge
            v-if="mx_isDispoView && mx_openAbsencesAtSelectedDateInDispoView.length > 0"
            :color="mx_dispoOpenStateColor"
            :content="mx_openAbsencesAtSelectedDateInDispoView.length"
            offset-x="-20"
            offset-y="-10"
          ></v-badge>
        </v-toolbar>
      </template>
      <template v-slot:footer v-if="mx_isZueri9View">
        <fahrdienst-stats-short
          horizontal
          class="d-flex pl-3"
          :current-date-formatted="currentDateFormatted"
          :zueri9-fahrdienst-stats="zueri9FahrdienstStats"
        ></fahrdienst-stats-short>
      </template>
    </absences-virtual-scroller>
    <absence-dialog
      @onClose="onCloseEditDialog"
      @onSave="saveEditedItem"
      @changeFzgType="onChangeFzgType"
      :editedItemReportedTime="editedItemReportedTime"
      :editedItemReportedDate="editedItemReportedDate"
      :editItem="editedItem"
      :isNew="!editedItem.id"
    ></absence-dialog>

    <v-dialog v-model="beforeForwardDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>Weiterleitung an {{ mx_isDispoView ? 'Züri 9' : 'Dispo' }}</v-card-title>

        <!-- Dispo Dialog Content -->
        <div v-show="mx_isDispoView">
          <v-card-text>
            <v-textarea outlined class="pl-2" label="Bemerkung" rows="3" v-model="forwardDialogValues.remarks"></v-textarea>
          </v-card-text>
        </div>

        <!-- Züri 9 Dialog Content -->
        <div v-show="mx_isZueri9View">
          <v-card-text> Wollen Sie diese Weiterleitung durchführen?</v-card-text>
        </div>

        <v-card-actions>
          <v-spacer>
            <v-btn color="primary" text @click="cancelForward">Abbrechen</v-btn>
            <v-btn color="primary" text @click="forwardItemConfirm">Weiterleiten</v-btn>
          </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="beforeMultipleForwardDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title> Weiterleitung an {{ mx_isDispoView ? 'Züri 9' : 'Dispo' }} </v-card-title>

        <!-- Dispo Dialog Content -->
        <div v-show="mx_isDispoView">
          <v-card-text>
            <p v-if="selectedItems.length > 1">Es werden {{ selectedItems.length }} Einträge weitergeleitet.</p>
            <p v-else>Es wird {{ selectedItems.length }} Eintrag weitergeleitet.</p>
            <v-textarea outlined class="pl-2" label="Bemerkung" rows="3" v-model="forwardDialogValues.remarks"></v-textarea>
          </v-card-text>
        </div>

        <v-card-actions>
          <v-spacer>
            <v-btn color="primary" text @click="cancelMultipleForward">Abbrechen</v-btn>
            <v-btn color="primary" text @click="forwardMultipleItemsConfirm">Weiterleiten</v-btn>
          </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="beforeRestoreDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title> Wollen Sie die Weiterleitung zurücknehmen?</v-card-title>
        <v-card-actions>
          <v-spacer>
            <v-btn color="primary" text @click="cancelRestore">Abbrechen</v-btn>
            <v-btn color="primary" text @click="restoreItemConfirm">Zurücknehmen</v-btn>
          </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" absolute right :timeout="1000">
      <div class="d-flex justify-center">{{ snackbarText }}</div>
    </v-snackbar>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
import dateUtils from '@/common/dateUtils';
import commonMixin from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import AbsenceDialog from './AbsenceDialog.vue';
import api from '../../api';
import CsvExportor from 'csv-exportor';
import { createMail } from './AbsenceMail';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import index from '../../index';
import configMixin from '@/mixins/configMixin';
import FahrdienstStats from '@/modules/customerVbzWorksheet/components/FahrdienstStats.vue';
import FahrdienstStatsShort from '@/modules/customerVbzWorksheet/components/FahrdienstStatsShort.vue';
import AbsencesVirtualScroller from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/AbsencesVirtualScroller.vue';
import absencesTableColumnsDispo from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsencesTableColumnsDispo';
import absencesTableColumnsZueri9 from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsencesTableColumnsZueri9';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import StateFilter from '@/modules/customerVbzWorksheet/components/StateFilter.vue';
import { DAY_IN_MS } from '@/common/constants';
import absencesTableColumnsZueri9CustomerView from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsencesTableColumnsZueri9CustomerView';
import absenceTemplateZueri9 from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsenceTemplateZueri9';
import absenceTemplateDispo from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsenceTemplateDispo';

let timer;
const DOMAIN = 'absence';
const defaultItem = { vbzNr: '', zueri9VbzNr: '', backup1: '', start: '', end: null, remark: '', phone: null };

export default {
  mixins: [dateTimeMixin, configMixin, commonMixin, wsMixin],
  components: {
    StateFilter,
    FahrdienstStatsShort,
    FahrdienstStats,
    AbsencesVirtualScroller,
    AbsenceDialog,
  },
  props: {
    height: { type: String, default: `calc(100vh - 430px)` },
    remainingHeight: Number,
  },
  created() {
    this.$socket.on('domain:lockItem', ({ domain, id, username, firstName, lastName }) => {
      console.debug(`socket domain:lockItem - User ${firstName} ${lastName} has locked ${domain} item with id ${id}`);
      if (domain === DOMAIN && this.items) {
        let itemWithId = this.items.find((item) => item.id === id);
        if (itemWithId) {
          Vue.set(itemWithId, 'lock', { username, firstName, lastName });
        }
      }
    });

    this.$socket.on('domain:releaseLockedItem', ({ domain, id, username, firstName, lastName }) => {
      console.debug(`socket domain:releaseLockedItem - User ${firstName} ${lastName} has releaseLockedItem ${domain} item with id ${id}`);
      if (domain === DOMAIN && this.items) {
        let itemWithId = this.items.find((item) => item.id === id);
        if (itemWithId) {
          Vue.delete(itemWithId, 'lock');
        }
      }
    });

    if (this.dataLoaded) {
      console.debug('Worksheet data is loaded. Calculate fahrdienstStats');
      this.calculateZueri9FahrdienstStats();
    }
    // setTimeout(()=>{ this.calculateZueri9FahrdienstStats();},2000)
  },

  beforeUpdate() {
    // console.debug('make sure, the socket.io room is joined.');
    this.$socket.emit('join-room', { room: 'vbzWorksheet' }, (response) => {
      console.debug(`join-room response: Status=${response.status} Message=${response.msg}`);
    });

    timer = Date.now();
  },

  data: () => ({
    fahrdienstStatsDialog: false,
    zueri9FahrdienstStats: {},
    selectedZueri9States: [],
    selectedDispoStates: [],
    search: '',
    currentItem: null,
    selectedRow: [],
    sortBy: 'reportedAtTime',
    sortDesc: false,
    isNotProductionMode: process.env.NODE_ENV !== 'production',

    mailToDialog: false,
    reportedDateDialog: false,
    deleteDialog: false,
    beforeMultipleForwardDialog: false,
    beforeForwardDialog: false,
    beforeRestoreDialog: false,
    editedItem: { vbzNr: null },
    editedItemReportedDate: null,
    editedItemReportedTime: null,

    dialog: false,
    snackbar: false,
    snackbarText: '',

    absenceDisplayMode: 'active',

    forwardDialogValues: {
      remarks: '',
      replacementLocation: '',
    },

    sortColumn: 'reportedAtTime',
    sortDir: 'desc',

    updateHint: true,

    // states used to restore previous state when cancelling absence editting
    itemBeforeEdit: null,
  }),

  computed: {
    ...mapState('vbzWorksheet', [
      'absences',
      'absencesByDate',
      'reasons',
      'reasonsById',
      'illnessReasons',
      'illnessReasonsById',
      'remarks',
      'remarksById',
      'absenceDurations',
      'absenceDurationsById',
      'zueri9ReasonsById',
      'zueri9ClientsById',
      'zueri9StatesById',
      'zueri9States',
      'zueri9Clients',
      'zueri9Reasons',
      'dispoStates',
      'dispoStatesById',
      'zueri9MonthlyExpectedHours',
      'contextDate',

      'userByCompanyNr',
      'absencesTableUpdated',
      'dataLoaded',
    ]),
    ...mapState('vbzWorksheet', {
      currentDate: (state) => state.contextDate,
    }),
    tableSorters() {
      return {
        fromTo: this.mx_fromToSorter,
        z9FromTo: this.mx_fromToZ9Sorter,
        absenceDurationId: this.mx_absenceDurationSorter,
        reasonId: this.mx_reasonSorter,
        backup1_until: this.mx_backup1UntilSorter,
        reportedAtTime: this.mx_reportedAtTimeSorter,
        zueri9VbzNr: this.mx_zueri9VbzNrSorter,
        fromToTwoLines: this.mx_fromToTwoLinesSorter,
        z9fromToTwoLines: this.mx_fromToZ9Sorter,
        z9FromToTwoLines: this.mx_fromToZ9Sorter,
        zueri9ClientAndReason: this.mx_zueri9ClientAndReasonSorter,
        zueri9Client: this.mx_zueri9ClientSorter,
        zueri9Reason: this.mx_zueri9ReasonSorter,
        zueri9State: this.mx_zueri9StateSorter,
        dispoState: this.mx_dispoStateSorter,
      };
    },
    columns() {
      let headers;
      if (this.mx_isDispoView) {
        headers = absencesTableColumnsDispo;
      } else if (this.mx_isZueri9View) {
        headers = absencesTableColumnsZueri9;
      } else {
        // default is zueri9CustomerView because read only
        headers = absencesTableColumnsZueri9CustomerView;
      }
      return headers
        .filter((header) => {
          if (header.displaySize === 'all') return true;
          if (header.displaySize === 'mdAndDown' && this.mdAndDown) return true;
          if (header.displaySize === 'lgAndUp' && this.lgAndUp) return true;
          return false;
        })
        .map((header) => {
          return { ...header, width: header.width };
        });
    },

    currentDateFormatted() {
      return this.formatAsLocaleShortDate(this.currentDate);
    },
    isCurrentMonth() {
      return this.contextDate.getMonth() === new Date().getMonth();
    },

    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    isDevEnv() {
      return process.env.NODE_ENV === 'dev';
    },
    /**
     * Find the expected hours per month either use the configured value from the module config parameter zueri9FahrstundenTagesRichtwert (in vbz/ui-config) or the user configured value in
     * zueri9MonthlyExpectedHour table
     */
    zueri9FahrstundenTagesRichtwert() {
      let fahrstundenTagesRichtwert = this.moduleConfig.zueri9FahrstundenTagesRichtwert;
      let currentMonth = this.contextDate.getMonth() + 1;
      let currentYear = this.contextDate.getFullYear();
      let configuredFahrstundenTagesRichtwert = this.zueri9MonthlyExpectedHours.find((item) => item.year === currentYear && item.month === currentMonth);
      const dailyExpectations = configuredFahrstundenTagesRichtwert ? configuredFahrstundenTagesRichtwert.hours : fahrstundenTagesRichtwert;

      console.debug(`Found configuredFahrstundenTagesRichtwert for ${currentYear}-${currentMonth}`, configuredFahrstundenTagesRichtwert);
      if (!configuredFahrstundenTagesRichtwert)
        console.debug(
          `If no configuredFahrstundenTagesRichtwert found, the default value from moduleConfig.zueri9FahrstundenTagesRichtwert is taken:${fahrstundenTagesRichtwert}`
        );
      return dailyExpectations;
    },

    items() {
      let deletedOnly = this.absenceDisplayMode === 'deleted';
      let ignoreDeleted = this.absenceDisplayMode === 'active';
      let currentDayKey = worksheetService.buildDateIdFromDate(this.currentDate);

      let absencesCurrentDay = this.absencesByDate[currentDayKey] || [];
      let dataFilterEnabled = false; //no data filtering required due to pre-filtering in absenceByDate
      let filtered = worksheetService.filterItems(this.currentDate, absencesCurrentDay, deletedOnly, ignoreDeleted, 'dutyFrom', dataFilterEnabled);

      if (this.mx_isZueri9View || this.mx_isZueri9CustomerView) {
        filtered = filtered.map((i) => ({
          ...i,
          disponent: i.redakteur || i.disponent,
        }));
      }

      if (this.mx_isZueri9CustomerView) {
        filtered = filtered.filter((i) => {
          return i.zueri9State === this.mx_zueri9StatesObj.completed.id;
        });
      }

      if (this.mx_isZueri9View || this.mx_isZueri9CustomerView) {
        filtered = filtered.filter((i) => {
          return i.assignedTo === 'zueri9' || (i.assignedTo === 'dispo' && i.zueri9State === this.mx_zueri9States.returnedToAuthor);
        });
      } else if (this.mx_isDispoView) {
        console.debug('filter dispo items');
        filtered = filtered.filter((i) => {
          return !i.clone && (i.assignedTo === 'dispo' || (i.assignedTo === 'zueri9' && i.dispoState));
        });
      }
      if (this.selectedDispoStates.length > 0 && this.mx_isDispoView) {
        filtered = filtered.filter((i) => this.selectedDispoStates.find((s) => s.id === i.dispoState));
      }
      if (this.selectedZueri9States.length && (this.mx_isZueri9View || this.mx_isZueri9CustomerView)) {
        filtered = filtered.filter((i) => this.selectedZueri9States.find((s) => s.id === i.zueri9State));
      }
      if (this.search) {
        let searchLowercase = this.search.toLowerCase();
        filtered = filtered.filter((i) => {
          let item = {};
          item.id = `${i.id}`;
          item.line = i.line;
          item.duty = i.duty;
          item.dutyFrom = dateUtils.formatTime(i.dutyFrom);
          item.dutyUntil = dateUtils.formatTime(i.dutyUntil);
          item.dutyFromLoc = i.dutyFromLoc;
          item.dutyUntilLoc = i.dutyUntilLoc;

          if (this.mx_isZueri9View) {
            item.person = this.mx_zueri9VbzNr(i);
            item.line = i.line;
            item.zueri9Client = this.mx_zueri9Client(i);
            item.zueri9Reason = this.mx_zueri9Reason(i);
            item.zueri9States = this.mx_zueri9State(i);
            item.remarks = i.remarks;
            item.editor = i.disponent;
          } else if (this.mx_isZueri9CustomerView) {
            item.person = this.mx_zueri9VbzNr(i);
            item.line = i.line;
            item.remarks = i.remarks;
          } else {
            item.person = i.vbzNr;
            item.backup1 = i.backup1;
            item.remark = this.mx_remark(i);
            item.reason = this.mx_reason(i);
            item.absenceDuration = this.mx_absenceDuration(i);
            item.disponent = i.disponent;
            item.redakteur = i.redakteur;
            item.dispoState = this.mx_dispoState(i);
          }
          let finding = Object.keys(item).find((key) => {
            let value = item[key];
            if (value && value.toLowerCase && value.includes) {
              return value.toLowerCase().includes(searchLowercase);
            }
          });
          return !!finding;
        });
      }
      let filteredAndSorted = filtered;

      if (this.sortColumn) {
        let colName = this.sortColumn;
        console.debug('sort by sortColumn', this.sortColumn);
        let tableSortFunc = this.tableSorters[colName];
        console.debug(`tableSortFunc for columnName=${colName}`, tableSortFunc);
        if (tableSortFunc) {
          filteredAndSorted = filtered.slice().sort(tableSortFunc);
        } else {
          filteredAndSorted = filtered.slice().sort((a, b) => {
            let valA = colName in a ? `${a[colName]}` : '';
            let valB = colName in b ? `${b[colName]}` : '';
            return valA.localeCompare(valB);
          });
        }
        if (this.sortDir === 'desc') {
          filteredAndSorted = filteredAndSorted.reverse();
        }
      }
      return filteredAndSorted;
    },
    selectedItems() {
      return this.items.filter((i) => i.isSelected);
    },
    formTitle() {
      return !this.editedItem.id ? 'Neue Meldung' : 'Meldung editieren';
    },
  },

  methods: {
    calculateZueri9FahrdienstStats() {
      console.debug('compute zueri9FahrdienstStats');
      if (this.mx_isDispoView) {
        this.zueri9FahrdienstStats = {};
      } else {
        const now = new Date();
        const isCurrentMonth = this.contextDate.getMonth() === now.getMonth() && this.contextDate.getFullYear() === now.getFullYear();
        const lastOfMonth = dateUtils.getLastDayOfMonth(this.contextDate.getFullYear(), this.contextDate.getMonth());
        console.debug(`LastOfMonth=${lastOfMonth.toISOString()}`);
        this.zueri9FahrdienstStats = worksheetService.calculateZueri9FahrdienstStats({
          absences: this.absences,
          currentWorksheetDate: isCurrentMonth ? this.contextDate : lastOfMonth,
          zueri9Clients: this.zueri9Clients,
          zueri9Reasons: this.zueri9Reasons,
          zueri9FahrstundenTagesRichtwert: this.zueri9FahrstundenTagesRichtwert,
        });

        console.debug('this.zueri9FahrdienstStats', this.zueri9FahrdienstStats);
      }
    },
    onSortColumn({ columnName, dir }) {
      console.debug('onSortColumn', columnName, dir);
      if (!dir) {
        this.sortColumn = 'reportedAtTime';
        this.sortDir = 'desc';
      } else {
        this.sortColumn = columnName;
        this.sortDir = dir;
      }
    },

    isAssignedToDifferentView(item) {
      return (item.assignedTo === 'dispo' && this.mx_isZueri9View) || (item.assignedTo === 'zueri9' && this.mx_isDispoView);
    },
    forwardItem(item) {
      item.assignedTo = !item.assignedTo || item.assignedTo === 'dispo' ? 'zueri9' : 'dispo';
      console.debug('forwarded item to', item.assignedTo);
      this.saveItem(item);
    },
    restoreForwardedItem(item) {
      this.forwardItem(item);
    },
    onChangeFzgType(fzgType) {
      Vue.set(this.editedItem, 'fzgType', fzgType);
    },

    ...mapMutations('vbzWorksheet', ['pushDomainItem', 'setAbsenceEditDialog']),

    /**
     * @desc Gets called whenever a row has changes
     * @param {Object} args holds the absence that changed
     * @param {Object} args.absence the changed absence
     * @param {string} args.property the name of the property that changed in the row
     */
    onInlineChange(args) {
      console.debug('onInlineChange', args.property, args.absence[args.property]);
      if (args.property !== 'isSelected') {
        this.saveItem(args.absence);
      }
    },

    // inlineChange(item, property) {
    //   console.debug('selectedRow', this.selectedRow);
    //   console.debug(`item changed property=${property} to ${item[property]}, item=${JSON.stringify(item, null, 2)}`);
    //   this.saveItem(item);
    // },

    formatTime(isoString) {
      return dateUtils.formatTime(isoString);
    },

    // actions
    exportCsv() {
      let tableData = this.items.map((item) => {
        return this.mx_isDispoView
          ? [
              item.id,
              this.mx_reason(item),
              item.crewReport ? 'ja' : 'nein',
              item.supervisorReport ? 'ja' : 'nein',
              `="${item.vbzNr ? item.vbzNr : ''}"`,
              `="${item.duty ? item.duty : ''}"`,
              this.mx_from(item),
              this.mx_fromLocation(item),
              this.mx_to(item),
              this.mx_toLocation(item),
              this.mx_timeDifferenceDecimal(item),
              `="${item.line ? item.line : ''}"`,

              item.backup1 || '',
              // item.backup1_reported ? 'ja' : 'nein',
              dateUtils.formatTime(item.backup1_until),
              item.backup2,
              // item.backup2_reported ? 'ja' : 'nein',
              this.mx_remark(item),
              this.mx_reportedAtTime(item),
              this.mx_absenceDuration(item),
              item.disponent,
            ]
          : [
              item.id,
              `="${this.mx_formatUserFromCompanyNr(item.zueri9VbzNr)}"`,
              `="${item.z9Duty ? item.z9Duty : ''}"`,
              this.mx_from(item, 'z9DutyFrom'),
              this.mx_fromLocation(item, 'z9DutyFromLoc'),
              this.mx_to(item, 'z9DutyUntil'),
              this.mx_toLocation(item, 'z9DutyUntilLoc'),
              this.mx_timeDifferenceDecimal(item, 'z9DutyFrom', 'z9DutyUntil'),
              `="${item.z9Line ? item.z9Line : ''}"`,

              this.mx_zueri9Client(item),
              this.mx_zueri9Reason(item),
              item.remarks,
              this.mx_zueri9State(item),
            ];
      });
      let header = this.mx_isDispoView
        ? [
            'ID',
            'Grund',
            'Crew ok',
            'Meldung Vorg.',
            'VBZ Nr.',
            'Dienst',
            'Dienstbeginn',
            'Dienst von',
            'Dienstende',
            'Dienst bis',
            'Dienst Dauer',
            'Linie/Kurs',

            'Ersatz 1',
            // 'Ersatz 1 ok',
            'Ersatz 1 bis',
            'Ersatz 2',
            // 'Ersatz 2 ok',
            'Bemerkung',
            'Meldung am',
            'Dauer der Abwesenheit',
            'Disponent',
          ]
        : [
            'ID',
            'BE-Mitarbeitende',
            'Dienst',

            'Dienstbeginn',
            'Dienst von',
            'Dienstende',
            'Dienst bis',
            'Dienst Dauer',
            'Linie/Kurs',

            'Für wen',
            'Was',
            'Bemerkung Dispo für Züri9',
            'Status',
          ];
      CsvExportor.downloadCsv(
        tableData,
        {
          header,
          cellDelimiter: ';',
        },
        `${this.mx_isDispoView ? 'Absenzen_' : 'BE Rapport '}${this.formatAsLocaleShortDate(this.currentDate)}.csv`
      );
    },
    onCloseEditDialog() {
      // Restore status
      let editedItem = this.items.find((i) => i.id === this.editedItem.id);
      if (editedItem && this.itemBeforeEdit) {
        Object.assign(editedItem, this.itemBeforeEdit);
      }

      this.removeAbsenceRowMarker(this.editedItem, 'edited-row');

      this.sendLockReleased(this.editedItem);

      this.editedItem = Object.assign({}, {});

      this.closeEditDialog();
      this.resetEdit();
    },
    closeEditDialog() {
      this.setAbsenceEditDialog({ value: false });
    },
    resetEdit() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, defaultItem);
      });
    },
    cancelDelete() {
      this.deleteDialog = false;
      this.sendLockReleased(this.editedItem);
      this.resetEdit();
    },
    /**
     * @desc Cancels the dialog responsible for multiple forwards. Resets variables and releases all items to be mutable again.
     */
    cancelMultipleForward() {
      this.beforeMultipleForwardDialog = false;
      this.forwardDialogValues.remarks = '';
      this.forwardDialogValues.replacementLocation = '';

      this.selectedItems.forEach((item) => {
        this.sendLockReleased(item);
      });
    },
    cancelForward() {
      this.beforeForwardDialog = false;
      this.forwardDialogValues.remarks = '';
      this.forwardDialogValues.replacementLocation = '';
      this.sendLockReleased(this.editedItem);
      this.resetEdit();
    },
    cancelRestore() {
      this.beforeRestoreDialog = false;
      this.sendLockReleased(this.editedItem);
      this.resetEdit();
    },
    copyItem(item) {
      // Create item
      let copy = Object.assign({}, item);
      copy.clone = `Kopie von ID ${copy.id}`;

      if (this.mx_isZueri9View) {
        console.debug('delete dispoState of züri9 copied item. This allows Züri 9 users to delete copied forwarded items. -> See Actions.vue');
        copy.dispoState = null;
      }

      delete copy['id'];
      this.$socket.emit('domain:create', DOMAIN, copy, (response) => {
        // console.debug('Copied absence object', response.data);
        this.pushDomainItem({ domain: DOMAIN, item: response.data });
        this.sortBy = 'reportedAtTime';
        this.sortDesc = false;
      });
    },

    async createMailto(item) {
      console.debug('createMailto item=', JSON.stringify(item, null, 2));
      let address = '';
      try {
        const userData = await api.findUserByCompanyNr(item.vbzNr);
        // console.debug('userData', JSON.stringify(userData.data, null, 2));
        let { user, boss, userRel } = userData.data;

        let address = boss ? boss.email : 'no-adress-found@vbz.ch';

        item.supervisorReport = true;
        await this.saveItem(item);
        let userName = user ? user.firstname + ' ' + user.lastname : 'nicht definiert';
        let { subject, body, mailTo } = createMail({
          address,
          absenceItem: item,
          reason: this.mx_reason(item),
          absenceDuration: this.mx_absenceDuration(item),
          remark: this.mx_remark(item),
          userName,
        });
        let a = document.getElementById(`mail_${item.id}`);
        if (a) {
          a.href = mailTo;

          window.open(mailTo);
        }
      } catch (err) {
        console.warn(`Failed to derive user-boss relation from vbzNr ${item.vbzNr}`);
      }
      //return mail;
    },
    showSnackbar({ text, sortByReportedAtTime }) {
      if (sortByReportedAtTime) {
        this.sortBy = 'reportedAtTime';
        this.sortDesc = true;
      }

      this.snackbar = true;
      this.snackbarText = text;
    },

    createItem() {
      this.editedItem = Object.assign({ _updated: null, _created: true }, this.mx_isZueri9View ? absenceTemplateZueri9 : absenceTemplateDispo);
      this.editedItem._mode = 'doubleRowCreate';
      this.editedItem.reportedAtTime = dateUtils.formatTime(new Date().toISOString());
      this.editedItem.reportedAtDate = new Date().toISOString();
      this.editedItem.fzgType = null;
      this.setAbsenceEditDialog({ value: true });
    },
    editItem(item) {
      this.itemBeforeEdit = { ...item };
      // this.markAbsenceRow(item,'edited-row')

      if (this.mx_isZueri9View && item.zueri9State === this.mx_zueri9States.open) {
        item.zueri9State = this.mx_zueri9States.inProgress;
      } else if (this.mx_isDispoView && item.dispoState === this.mx_dispoStates.open) {
        item.dispoState = this.mx_dispoStates.inProgress;
      }
      // lock row
      this.sendLock(item);
      this.updateHint = !this.updateHint;
      this.editedItem = Object.assign({ _updated: true, vbzNr: '' }, item);

      this.editedItem._mode = 'singleRowEdit';
      console.debug(`dutyFrom ${this.editedItem.dutyFrom}`);

      this.setAbsenceEditDialog({ value: true });
    },
    /**
     * Saves the editedItem
     */
    save(editedItem) {
      console.debug('save editedItem', editedItem);
      this.saveItem(editedItem);
    },
    saveEditedItem() {
      this.saveItem(this.editedItem);
    },
    /**
     * Saves the provided item
     */
    async saveItem(e) {
      // console.debug('saveItem', JSON.stringify(e, null, 2));
      this.removeAbsenceRowMarker(e, 'edited-row');
      console.debug(`saveItem with recordDate: currentDate=${this.currentDate}, contextDate=${this.contextDate}`);
      e.recordDate = this.currentDate;

      let dutyFrom = e.dutyFrom;
      let dutyUntil = e.dutyUntil;

      let dutyDateFallback = this.currentDate;

      let dutyFromTime = Date.parse(dutyFrom);
      let dutyUntilTime = Date.parse(dutyUntil);

      if (dutyFrom && dutyUntil && dutyFromTime > dutyUntilTime) {
        dutyUntil = new Date(dutyUntilTime + DAY_IN_MS).toISOString();
      }

      let backup1_until = e.backup1_until;
      let reportedAtTime = e.reportedAtTime;
      console.debug('saveItem', e);

      let currentUserName = this.$store.state.profile.user.userName;

      // resolve selected illness reason from dropdown
      let illnessReason = this.illnessReasons.find((ir) => ir.id === e.illnessReasonId);
      if (illnessReason) {
        illnessReason = illnessReason.text;
      } else if (e.illnessReason) {
        // illness reason dropdown "Diverses" selected, use freetext entry illnessReason
        illnessReason = `Diverses: ${e.illnessReason}`;
      }

      if (illnessReason) {
        // Store anonymous illness reason
        let fzgType = e.fzgType;
        let illnessReasonSendItem = { date: this.currentDate, reason: illnessReason, fzgType };
        console.debug('Store anonymous illness reason', this.currentDate, illnessReasonSendItem);

        this.$socket.emit('domain:create', 'anonymousIllnessReason', illnessReasonSendItem, (socketResponse) => {
          console.debug('Saved IllnessReason', socketResponse.data);
        });
      }

      let sendItem = {
        ...e,
        dutyDateFallback,
        reportedAtTime,
        dutyFrom,
        dutyUntil,
        backup1_until,
        illnessReason,

        _updated: true,
      };
      // console.debug('saveItem', JSON.stringify(sendItem, null, 2));
      if (e.id) {
        // Update item
        sendItem.redakteur = currentUserName;

        let oldItem = this.absences.find((i) => i.id === e.id); //must search within raw list as this.items is already filtered by assignedTo
        if (oldItem) {
          //sendItem.dutySelection.dutySelectionPart=0; // dutySelection part 1(index 0) for new items
          if (!sendItem.dutySelection || !sendItem.dutySelection.resolvedDutyActivities) {
            // In case the new item has no dutySelection (meaning no duty selected by dutyLookup assistant), create a "handmade" duty
            sendItem.dutySelection = worksheetService.createDutySelectionFromHandmadeDutyParts(sendItem, this.mx_isZueri9View);
            console.debug(`update selectedDutyParts ${JSON.stringify(sendItem.dutySelection, null, 2)}`);
          } else {
            let dutySelection = e.dutySelection || {};
            sendItem.dutySelection.selectedDutyParts = dutySelection.selectedDutyParts;
            sendItem.dutySelection.resolvedDutyActivities = dutySelection.resolvedDutyActivities;
            console.debug('update item with a given dutySelection e.dutySelection', e.dutySelection);
            console.debug('update item sendItem.dutySelection', sendItem.dutySelection);
          }

          this.$socket.emit('domain:update', DOMAIN, sendItem, (response) => {
            let newItem = response.data;
            this.updateAbsence(oldItem, newItem);
            this.showSnackbar({ text: 'gespeichert', sortByReportedAtTime: false });

            this.closeEditDialog();

            console.debug('updatedItem calculateZueri9FahrdienstStats');
            this.calculateZueri9FahrdienstStats();
          });
        } else {
          console.warn(`Failed to find item with id=${e.id}`);
        }
      } else {
        // create item
        sendItem.disponent = currentUserName;

        if (!e.dutySelection) {
          e.dutySelection = worksheetService.createDutySelectionFromHandmadeDutyParts(sendItem, this.mx_isZueri9View);
          e.dutySelection.dutySelectionPart = 0;

          console.debug(`selectedDutyParts ${JSON.stringify(e.dutySelection, null, 2)}`);
        }

        sendItem.dutySelection = { ...e.dutySelection };
        sendItem.dutySelection.dutySelectionPart = 0; // dutySelection part 1(index 0) for new items
        if (this.mx_isDispoView) {
          if (!sendItem.dispoState) {
            sendItem.dispoState = this.mx_dispoStates.open;
          }
        }

        // Create first duty item
        this.$socket.emit('domain:create', DOMAIN, sendItem, (response) => {
          console.debug('created item via socket.io. Response:', response.data);

          const object1 = response.data;
          object1._created = true;
          worksheetService.clearUpdateAndCreatedMarks(object1, 15);

          // If one of the 2nd duty fields is filled,a second item is created
          // Create second duty item with most fields copied but individual duty, dutyFrom, dutyUntil fields
          if (!e.duty2 || this.mx_isZueri9View) {
            this.closeEditDialog();
            this.pushDomainItem({ domain: DOMAIN, item: object1 });
            this.showSnackbar({ text: 'gespeichert', sortByReportedAtTime: true });
            console.debug('saved item calculateZueri9FahrdienstStats');
            this.calculateZueri9FahrdienstStats();
          } else if (this.mx_isDispoView) {
            let sendItem2 = Object.assign({}, sendItem);
            sendItem2.reportedAtTime = new Date(Date.parse(reportedAtTime) - 1000); // object1.reportedAtTime;
            sendItem2.duty = e.duty2;
            sendItem2.dutyFrom = e.dutyFrom2;

            sendItem2.dutyFromLoc = e.dutyFromLoc2;

            sendItem2.dutyUntil = e.dutyUntil2;

            sendItem2.dutyUntilLoc = e.dutyUntilLoc2;

            sendItem2.line = e.line2;

            sendItem2.remarkId = null;
            sendItem2.absenceDurationId = null;
            sendItem2.backup1 = null;
            sendItem2.backup1_until = null;
            // sendItem2.backup2 = nullor
            sendItem2.backup1_reported = false;
            sendItem2.backup2_reported = false;

            sendItem2.dutySelection = { ...e.dutySelection, dutySelectionPart: 1 };
            this.$socket.emit('domain:create', DOMAIN, sendItem2, (response) => {
              const object2 = response.data;
              object2._created = true;
              worksheetService.clearUpdateAndCreatedMarks(object2, 15);
              this.pushDomainItem({ domain: DOMAIN, item: object1 });
              this.pushDomainItem({ domain: DOMAIN, item: object2 });
              this.showSnackbar({ text: 'gespeichert', sortByReportedAtTime: true });

              console.debug('saved 2 items calculateZueri9FahrdienstStats');
              this.calculateZueri9FahrdienstStats();

              this.closeEditDialog();
            });
          }
        });
      }
    },
    /**
     * Calling the dialog to show while locking all the items in the table to not be mutable
     * @param {Object[]} items
     */
    showMultipleForwardDialog(items) {
      if (items.length > 0) {
        items.forEach((item) => {
          this.sendLock(item);
        });
        this.beforeMultipleForwardDialog = true;
      }
    },
    showForwardDialog(item) {
      // lock row
      this.sendLock(item);

      this.editedItem = Object.assign({}, item);
      this.beforeForwardDialog = true;
    },
    markAbsenceRow(absence, marker) {
      let el = document.getElementById(`abs_${absence.id}`);
      if (el) {
        el.classList.add(marker);
      }
    },
    removeAbsenceRowMarker(absence, marker) {
      let el = document.getElementById(`abs_${absence.id}`);
      if (el) {
        el.classList.remove(marker);
      }
    },
    updateAbsence(oldItem, newItem) {
      Object.keys(newItem).forEach((k) => {
        oldItem[k] = newItem[k];
      });
    },
    showDeleteDialog(item) {
      // lock row
      this.sendLock(item);
      // Comment on the way we lock rows here: There is no check if another user has locked a row because that would require to maintain the lock state on the database.
      // However a lock is set and broadcasted to all clients and write operations are locked like so for other users.
      // This mechanism might not be stable enough in case a user is not online at the time of setting the lock.
      // Thus if we see issues with this, we need to return to storing the lock onto the DB.
      this.editedItem = item; //Object.assign({}, item);
      this.deleteDialog = true;
    },
    /**
     * Toggles the delete flag of an item
     */
    deleteItemConfirm() {
      let editedItem = this.editedItem;
      // let index = this.absences.findIndex((a) => editedItem.id === a.id);

      // delete action toggles the deleted flag
      this.$socket.emit('domain:delete', DOMAIN, editedItem, (response) => {
        let deletedItem = response.softDeleted;

        // Object assign destroys deep reactivity, directly assign
        editedItem.deleted = deletedItem.deleted; // toggle deleted flag
        //or this.absences[index].deleted=deletedItem.deleted;
      });
      this.deleteDialog = false;
    },
    showRestoreDialog(item) {
      this.sendLock(item);
      this.editedItem = item; //Object.assign({}, item);
      this.beforeRestoreDialog = true;
    },
    restoreItemConfirm() {
      const editedItem = this.editedItem;
      editedItem.dispoState = this.mx_dispoStates.returnedAndOpen;
      editedItem.zueri9State = this.mx_zueri9States.returnedToAuthor;
      editedItem.assignedTo = !editedItem.assignedTo || editedItem.assignedTo === 'dispo' ? 'zueri9' : 'dispo';
      this.saveItem(editedItem);

      this.beforeRestoreDialog = false;
    },

    forwardMultipleItemsConfirm() {
      // const multipleForwards = this.selectedForwardingArray;
      const multipleForwards = this.selectedItems;

      multipleForwards.forEach((item) => {
        item.assignedTo = !item.assignedTo || item.assignedTo === 'dispo' ? 'zueri9' : 'dispo';
        if (this.mx_isDispoView) {
          item.dispoState = this.mx_dispoStates.forwarded;
          item.zueri9State = this.mx_zueri9States.open;
          item.remarks = this.forwardDialogValues.remarks;
          item.replacementLocation = this.forwardDialogValues.replacementLocation;
          item.isSelected = false;

          this.copyFieldsFromDispoToZueri9View(item);
        }
        this.saveItem(item);
      });

      this.forwardDialogValues.remarks = '';
      this.forwardDialogValues.replacementLocation = '';
      this.beforeMultipleForwardDialog = false;
    },
    copyFieldsFromDispoToZueri9View(item) {
      item.z9Duty = item.duty;
      item.z9DutyFrom = item.dutyFrom;
      item.z9DutyFromLoc = item.dutyFromLoc;
      item.z9DutyUntil = item.dutyUntil;
      item.z9DutyUntilLoc = item.dutyUntilLoc;
      item.z9Line = item.line;
    },

    forwardItemConfirm() {
      const item = this.editedItem;

      item.assignedTo = !item.assignedTo || item.assignedTo === 'dispo' ? 'zueri9' : 'dispo';
      if (this.mx_isDispoView) {
        item.dispoState = this.mx_dispoStates.forwarded;
        item.zueri9State = this.mx_zueri9States.open;
        item.remarks = this.forwardDialogValues.remarks;
        item.replacementLocation = this.forwardDialogValues.replacementLocation;

        // editable items in züri9 view must be separated from dispo view
        item.z9Duty = item.duty;
        item.z9FromTo = item.fromTo;

        this.copyFieldsFromDispoToZueri9View(item);
      }
      this.saveItem(item);

      this.forwardDialogValues.remarks = '';
      this.forwardDialogValues.replacementLocation = '';
      this.beforeForwardDialog = false;
    },
    // Lock operations
    sendLock(item) {
      this.$socket.emit('domain:lockItem', { domain: DOMAIN, id: item.id }, (response) => {
        console.debug(`domain absence locked item ${item.id} ${response.status} Message=${response.msg}`);
      });
    },
    sendLockReleased(item) {
      this.$socket.emit('domain:releaseLockedItem', { domain: DOMAIN, id: item.id }, (response) => {
        console.debug(`domain absence releaseLockedItem item ${item.id} ${response.status} Message=${response.msg}`);
      });
    },
  },
  watch: {
    fahrdienstStatsDialog(newValue, oldValue) {
      if (newValue) {
        this.calculateZueri9FahrdienstStats();
      }
    },
    contextDate() {
      this.calculateZueri9FahrdienstStats();
    },
    mx_isZueri9View(newValue, oldValue) {
      if (newValue && !oldValue) {
        console.debug('mx_isZueri9View transitioned from false to true. Calculate FahrdienstStats');
        this.calculateZueri9FahrdienstStats();
      }
    },
    dataLoaded(newValue, oldValue) {
      if (newValue && !oldValue) {
        console.debug('worksheet data loading state transitioned from false to true. Calculate FahrdienstStats');
        this.calculateZueri9FahrdienstStats();
      }
    },
  },
};
</script>
